"use strict";

exports.__esModule = true;
exports.Screen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _ErrorBoundary = require("../ErrorBoundary");
var _excluded = ["children", "title"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ScreenView = _styledComponents["default"].main.withConfig({
  displayName: "Screen__ScreenView",
  componentId: "sc-n0mnqr-0"
})(["display:flex;flex-direction:column;height:100vh;background:", ";.", " &{background:", ";}width:100%;"], (0, _Theme.val)("ScreenBackground"), _core.Classes.DARK, (0, _Theme.val)("DarkScreenBackground"));
var Screen = exports.Screen = /*#__PURE__*/function (_Component) {
  function Screen() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.currentTitle = document.title;
    _this.previousTitle = document.title;
    return _this;
  }
  _inheritsLoose(Screen, _Component);
  var _proto = Screen.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var title = this.props.title;
    if (title) {
      this.currentTitle = title;
      document.title = title;
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.title !== this.currentTitle) {
      document.title = this.props.title;
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.title = this.previousTitle;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      _title = _this$props.title,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(ScreenView, extra, children));
  };
  return Screen;
}(_react.Component);